
import React from "react";
import { i18nManager } from "../../../../i18n";
import { Siren } from "../../../shared/ConfirmDialog";
import LoadingGif from "../../../../assets/images/loading_circle.gif";
import { BaseService, HostService, IHost, IMember, IProfileWebsite, ITeam, MemberService, SanitizedResponse } from "../../../../services";
import PageDesign from "../../../page_design/PageDesign";
import MobileAppDesign from "../../../page_design/MobileAppDesign";

export interface DesignProps {
    host: IHost;
    profile: IMember;
}

function Design(_: DesignProps) {

    const hostService = HostService.getInstance();

    return (<div className="profile-settings team-settings"><MobileAppDesign /></div>);

}

export default Design;
